import React from "react";
import Loader from "./Loader";

const VARIANT_COLOR_MAP = {
  primary: {
    contained: "bg-[#202D66] text-white border-[#202D66]",
    outlined: "!border-[#202D66] text-[#202D66]",
    text: "border-none bg-transparent text-[#202D66]",
  },
  error: {
    contained: "bg-[#F43F5E] text-white border-[#F43F5E]",
    outlined: "!border-[#F43F5E] text-[#F43F5E]",
    text: "border-none bg-transparent text-[#F43F5E]",
  },
  success: {
    contained: "bg-[#37A372] text-white border-[#37A372]",
    outlined: "!border-[#37A372] text-[#37A372]",
    text: "border-none bg-transparent text-[#37A372]",
  },
  neutral: {
    contained: "bg-[#FFFFFF] text-[#475569] border-[#CBD5E1]",
    outlined: "!border-[#CBD5E1] text-[#475569]",
    text: "border-none bg-transparent text-[#475569]",
  },
  gray: {
    contained: "text-[#475569] border-[#E2E8F0] bg-[#F1F5F9]",
    outlined: "!border-[#E2E8F0] text-[#475569]",
    text: "border-none bg-transparent text-[#475569]",
  },
};
const SIZE_MAP = {
  sm: "h-9 px-2.5 text-xs",
  md: "h-10 px-3 text-sm",
  lg: "h-12 px-6 text-sm",
};

const Button = ({
  text,
  icon,
  endIcon,
  onClick,
  loading = false,
  disabled = false,
  color,
  variant,
  size,
  fullWidth = false,
  buttonType = "button",
  className = "",
}) => {
  // ✅ HARD DEFAULTS (even if props are undefined or invalid)
  const resolvedType = VARIANT_COLOR_MAP[color] ? color : "primary";

  const resolvedVariant = VARIANT_COLOR_MAP[resolvedType][variant]
    ? variant
    : "contained";

  const resolvedSize = SIZE_MAP[size] ? size : "md";
  const borderClass =
    resolvedVariant === "contained" || resolvedVariant === "outlined"
      ? "border"
      : "border-none";
  const defaulFlex = !className.includes("flex")
    ? "flex items-center justify-center gap-2"
    : "";
  return (
    <button
      type={buttonType}
      onClick={onClick}
      disabled={disabled || loading}
      className={`
        box-border
        rounded-full
        font-medium
        ${defaulFlex}
        transition-all
        ${borderClass}
        ${SIZE_MAP[resolvedSize]}
        ${VARIANT_COLOR_MAP[resolvedType][resolvedVariant]}
        ${fullWidth ? "w-full" : "w-auto"}
        ${disabled || loading ? "opacity-50 cursor-not-allowed" : "hover:opacity-90"}
        ${className}
    `}
    >
      {!loading && icon}
      {text}
      {loading && <Loader className="h-4 w-4 animate-spin" />}
      {!loading && endIcon}
    </button>
  );
};

export default Button;
